import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row pb-3 pt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex lg9" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Contract Details")
], -1)
const _hoisted_3 = { class: "flex lg3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_6 = { class: "container pl-3" }
const _hoisted_7 = { class: "row pb-1" }
const _hoisted_8 = { class: "row pb-1" }
const _hoisted_9 = { class: "flex sm6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Events")
], -1)
const _hoisted_11 = { class: "layout pl-3" }
const _hoisted_12 = { class: "row ml-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Add an Activity")
const _hoisted_14 = { class: "pt-3 pb-3" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex lg9" }, null, -1)
const _hoisted_17 = { class: "flex lg3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_ContractInput = _resolveComponent("ContractInput")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_EditContractActivity = _resolveComponent("EditContractActivity")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_card_title = _resolveComponent("va-card-title")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_va_button, {
          size: "medium",
          class: "mr-4",
          icon: "edit",
          onClick: _ctx.save
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_va_button, {
          size: "medium",
          icon: "cancel",
          onClick: _ctx.cancel
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_va_input, {
          class: "flex sm4",
          label: "Protocol",
          readonly: "",
          modelValue: _ctx.protocolName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.protocolName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_va_input, {
          class: "flex sm6",
          label: "Contract name",
          modelValue: _ctx.contractName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contractName) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_va_select, {
          class: "flex sm4",
          label: "Chain",
          modelValue: _ctx.contractChain,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contractChain) = $event)),
          options: _ctx.protocolChains,
          rules: [_ctx.contractChain != undefined || 'Select a chain']
        }, null, 8, ["modelValue", "options", "rules"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ContractInput, {
            initialAddress: _ctx.contractAddress,
            showToken: true,
            chain: _ctx.contractChain,
            onAddress: _ctx.setContractAddress
          }, null, 8, ["initialAddress", "chain", "onAddress"])
        ])
      ])
    ]),
    _createVNode(_component_va_divider),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractActivities, (contractActivity) => {
          return (_openBlock(), _createBlock(_component_va_card, {
            bordered: "",
            class: "flex sm12 md6 lg6 mb-2",
            key: contractActivity.id
          }, {
            default: _withCtx(() => [
              _createVNode(_component_EditContractActivity, {
                contractActivity: contractActivity,
                onActivityDelete: _ctx.contractActivityDeleted
              }, null, 8, ["contractActivity", "onActivityDelete"])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_va_card, {
          bordered: "",
          class: "flex sm12 md6 lg6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_card_title, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_EditContractActivity, { onActivityAdd: _ctx.addActivity }, null, 8, ["onActivityAdd"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_va_button, {
            size: "medium",
            class: "mr-4",
            icon: "edit",
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_va_button, {
            size: "medium",
            icon: "cancel",
            onClick: _ctx.cancel
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}